<template>
  <v-container>
    <div style="background-color: #ffffff" id="pdfContent" class="p-3">
      <b-row class="dashed-border pb-3">
        <b-col class="box-border info-box d-flex align-items-center">
          <h5>TAX INVOICE</h5>
        </b-col>
        <b-col class="box-border info-box">
          <p>Order Id: {{ invoiceData ? invoiceData.orderId : "" }}</p>
          <p>Order Date: {{ createdDate }}</p>
        </b-col>
        <!-- <b-col class="box-border info-box">
              <p>Invoice No: FABNE26646416</p>
              <p>Invoice Date: 20-10-22 02:42 pm</p>
            </b-col> -->
        <b-col class="info-box">
          <!-- <p>GSTIN: 29BKDPM1684168</p> -->
          <p>Payment Mode: COD</p>
        </b-col>
      </b-row>
      <b-row class="dashed-border">
        <b-col md="12">
          <div class="d-flex flex-column align-items-center mt-3 seller-box">
            <b-img
              :src="
                objData.provider &&
                objData.provider.organization &&
                objData.provider.organization.logo
                  ? objData.provider.organization.logo.url
                  : ''
              "
              width="50"
              height="50"
              alt=""
            />
            <h5 class="mb-2">
              {{
                objData.provider && objData.provider.organization
                  ? objData.provider.organization.name
                  : ""
              }}
            </h5>
            <p>
              {{
                objData.provider &&
                objData.provider.office &&
                objData.provider.office.address
                  ? objData.provider.office.address.city
                  : ""
              }}
            </p>
            <p>
              {{
                objData.provider &&
                objData.provider.office &&
                objData.provider.office.address
                  ? objData.provider.office.address.state
                  : ""
              }}
              -
              {{
                objData.provider.office && objData.provider.office.address
                  ? objData.provider.office.address.zip
                  : ""
              }}
            </p>
            <p>
              Phone:
              {{
                objData.provider &&
                objData.provider.authentication &&
                objData.provider.authentication.phone
              }}
            </p>
          </div></b-col
        >
      </b-row>
      <b-row class="dashed-border">
        <b-col md="3"> <h6>Item</h6></b-col>
        <b-col md="1"> <h6>Qty</h6> </b-col>
        <b-col md="2"> <h6>MRP</h6> </b-col>
        <b-col md="2"> <h6>Base Price</h6> </b-col>
        <b-col md="1"> <h6>Tax</h6> </b-col>
        <b-col md="3"> <h6 class="text-right">Amount(₹)</h6> </b-col>
      </b-row>
      <b-row class="dashed-border">
        <div
          class="d-flex w-100"
          v-for="item in invoiceData.ItemsByProvider"
          :key="item._id"
        >
          <b-col md="3">
            <p>{{ item.name }}</p></b-col
          >
          <b-col md="1">
            <p>{{ item.qty }}</p>
          </b-col>
          <b-col md="2">
            <p>{{ item.unitPrice }}</p>
          </b-col>
          <b-col md="2">
            <p>{{ item.price }}</p>
          </b-col>
          <b-col md="1">
            <p>{{ item.totalTaxes }}</p>
          </b-col>
          <b-col md="3">
            <p class="text-right pr-2">{{ item.finalPrice.toFixed(2) }}</p>
          </b-col>
        </div>
      </b-row>
      <b-row class="dashed-border">
        <b-col md="3"> <h6>Total</h6></b-col>
        <b-col md="5">
          <h6>
            {{ Object.keys(invoiceData && invoiceData.ItemsByProvider).length }}
          </h6>
        </b-col>
        <b-col md="1">
          <h6>{{ totalTaxAmount.toFixed(2) }}</h6>
        </b-col>
        <b-col md="3">
          <h6 class="text-right pr-2">{{ totalAmount }}</h6>
        </b-col>
      </b-row>
      <!-- <b-row class="dashed-border d-flex justify-content-end">
            <b-col md="1"> <p>CGST</p> </b-col>
            <b-col md="3">
              <p class="text-right pr-2">15</p>
            </b-col>
          </b-row> -->
      <b-row>
        <b-col md="12"
          ><div
            class="d-flex flex-column align-items-center mt-4 dashed-border"
          >
            <!-- <p>You have saved Rs.200+ on this order + eligible Cash Back</p> -->
            <p>Thank You for shoping with us</p>
            <p>Vist us again</p>
          </div>
        </b-col>
      </b-row>
    </div>
    <b-row>
      <b-col md="12" class="mt-2">
        <div class="text-center">
          <button
            type="button"
            class="btn btn-primary"
            @click="downloadInvoicePdf"
          >
            <span class="pr-3 pl-3">Download Invoice</span>
          </button>
        </div>
      </b-col>
    </b-row>
  </v-container>
</template>

<script>
import moment from "moment";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { mapState } from "vuex";

export default {
  data() {
    return {};
  },
  computed: {
    ...mapState({
      objData: state => state.order.orderDetailsData,
      invoiceData: state => state.order.invoiceDetails,
      orderList: state => state.order.listOrderAllUsers,
      sellerInfo: state => state.partner.partnerDetailsById,
    }),
    createdDate() {
      return moment(this.objData.createdAt).format("DD-MM-YYYY, hh:mm A");
    },
    // async orderInfo() {
    //   let orderObject = this.orderList.find(
    //     (obj) => obj._id === this.$route.params.orderId
    //   );
    //   await this.$store.dispatch(
    //     "partner/fetchPartnerDetailsById",
    //     orderObject.provider
    //   );
    //   return orderObject;
    // },
    // sellerPhone() {
    //   const number = this.sellerInfo?.office?.phone?.map((each) => each.number);
    //   return number[0];
    // },
    totalTaxAmount() {
      let taxes =
        this.invoiceData &&
        this.invoiceData.ItemsByProvider.map(each => each.totalTaxes);
      let tax = 0;
      for (let i = 0; i < taxes.length; i++) {
        tax = tax + taxes[i];
      }
      return tax;
    },
    totalAmount() {
      let totalBill = this.invoiceData.ItemsByProvider.map(
        each => each.finalPrice
      );
      let total = 0;
      for (let i = 0; i < totalBill.length; i++) {
        total = total + totalBill[i];
      }
      return total.toFixed(2);
    },
  },
  methods: {
    downloadInvoicePdf() {
      const pdfDoc = document.querySelector("#pdfContent");
      html2canvas(pdfDoc).then(canvas => {
        var imgData = canvas.toDataURL("image/png");
        var doc = new jsPDF("p");
        doc.addImage(imgData, "JPEG", 10, 10, 190, 280);
        doc.save("invoice.pdf");
      });
    },
  },
  async mounted() {
    await this.$store.dispatch("order/fetchInvoiceData", this.$route.params.id);
    await this.$store.dispatch(
      "order/getOrderDetails",
      this.$route.params.orderId
    );
  },
};
</script>

<style scoped>
.dashed-border {
  border-bottom: 2px dashed #e3e3e3;
}
.box-border {
  border-right: 2px dashed #e3e3e3;
}
.info-box p,
h5 {
  margin-bottom: 0px;
}
.seller-box p {
  margin-bottom: 0.3rem;
}
</style>
